import { render, staticRenderFns } from "./RadioSelection.vue?vue&type=template&id=5c02fae8&"
import script from "./RadioSelection.vue?vue&type=script&lang=ts&"
export * from "./RadioSelection.vue?vue&type=script&lang=ts&"
import style0 from "./RadioSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports